<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- 头部 -->
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>CONSTRUCTION</h1>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="tabs tabs-style-linebox hidden-xs">
      <div class="zznav">
        <ul class="zzitem">
          <li><a @click="forId('hysg')">HUAYIN PROJECT</a></li>
          <li><a @click="forId('cpjs')">PRODUCT DESCRIPTION</a></li>
        </ul>
      </div>
    </div>
    <!-- 小滚轮 -->
    <div id="ss_menu">
      <div>
        <i
          ><a @click="forId('cpjs')">Product<br />Description</a></i
        >
      </div>
      <div>
        <i
          ><a @click="forId('hysg')">Huayin<br />Project</a></i
        >
      </div>
      <div class="menu">
        <div class="share" id="ss_toggle" data-rot="180">
          <div class="circle"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <!-- 华胤施工 -->
    <div class="jzcontainer" id="hysg">
      <div class="jzleft">
        <h1 class="jzh">Huayin Project</h1>
        <p class="jzp">
          Huayin project management teams have completed over 2000 projects in
          China and have accumulated invaluable project management
          experience.<br />By using our management system conducted by assigned
          project managers, all projects are controlled and managed
          efficiently.<br />Our experienced project managers always keep close
          cooperation with the clients, design institutes, supervision
          companies, government officials and main contractors to ensure that
          project is processing smoothly.<br />Effective measures are enforced
          to insure that site safety is carried out to standard requirements.
          Our thoughtful after-sales service further wins the trust of our
          customers.
        </p>
      </div>
      <div class="jzright">
        <img v-lazy="hyjz1" alt="Lazy-loaded Image" class="jzimg" />
      </div>
    </div>
    <!-- 产品介绍 -->
    <div id="cpjs">
      <h1 class="jzcph">Product Description</h1>
    </div>

    <div class="jzcp">
      <div class="visible-xs">
        <div class="cd-image-block">
          <ul class="cd-images-list">
            <li class="is-selected">
              <a href="#0">
                <h2>Ventilating System</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>Translucent System</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>floor system</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>wall system</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>roof system</h2>
              </a>
            </li>

            <li>
              <a href="#0">
                <h2>Purlins & Girts</h2>
              </a>
            </li>
            <li>
              <a href="#0">
                <h2>main steel system</h2>
              </a>
            </li>
            <li>
              <a href="#0">
                <h2>prefabricated structure</h2>
              </a>
            </li>
          </ul>
          <!-- .cd-images-list -->
          <ul class="block-navigation">
            <li>
              <button class="cd-prev inactive jzbutton">&larr; Previous</button>
            </li>
            <li><button class="cd-next jzbutton">Next &rarr;</button></li>
          </ul>
          <!-- .block-navigation -->
        </div>
        <!-- .cd-image-block -->

        <div class="cd-content-block">
          <ul>
            <li class="is-selected">
              <div>
                <h2>Ventilating System</h2>
                <p>HUAYIN Natural Ventilator System</p>
                <p>
                  HUAYIN natural ventilator system utilizes the indoor
                  temperature difference that produces thermo dynamic force,
                  this effect further creates suctions inside the building:
                  fresh air can be drawn from the openings on the lower part of
                  the walls into the building. Polluted hot air and poisonous
                  gas can be exhausted from inside the building.<br />
                  Advantages compared to the power generated ventilator system:
                  •Economical and low cost •Automatic adjustment to the
                  air-exchange quantity •Quiet and no vibration •Professional
                  design, fast and convenient installation
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>Translucent System</h2>

                <p>Translucent Panel</p>

                <p>
                  Translucent panel provides most effective and harmless natural
                  light for the building.No electricity and maintenance is
                  required.<br />
                  Panel surface laminated with DuPont”s Melinex polyester film
                  that resist 99%of UV rays and reduce surface erosion.<br />
                  Light transmission value: transparent color(70%); milky white
                  color(58%)
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>floor system</h2>

                <p>
                  The reduction in structural load to the foundation is obvious
                  that further results in the saving of foundation cost.<br />
                  The floor deck is composed of our composite panel and the
                  on-site concrete placement to form a composite floor system
                  that avoids the making of time-consuming temporary form-works.
                  The Steel floor decks have, for long time, been recognized for
                  their economical factor because of the lightweight and high
                  strength-to-weight ratio, the system provides durable and
                  attractive floor system to suit all-weather construction.
                </p>

                <p>
                  FE-2W floor deck<br />
                  The HUAYIN FE-2W model composite floor deck possesses
                  proprietary technology of（ZL99241901.1）, which is designed
                  to suit for office building, light-load industry building and
                  high-rise building that has special requirements on floor deck
                  thickness.
                </p>

                <p>
                  FE-3W floor deck<br />
                  The HUAYIN FE-3W composite floor deck design possesses two
                  patent rights of the products （ZL00261986.5 ZL99241801.1）,
                  which is developed especially for the heavy load or large span
                  girder and that of high-rise building.
                </p>
              </div>
            </li>

            <li>
              <div>
                <h2>wall system</h2>
                <p>
                  CDII Wall System<br />
                  Wall panel system with exposed screws,Economical and easy
                  assembly type, widely applied in all types of building. RD
                  Wall System<br />
                  RD wall has unique wave crest that generate different vertical
                  shadow lines on the walls that gives a unique architectural
                  view. Economical and easy assembly type, widely applied in all
                  types of building PD Wall System<br />
                  PD wall system utilizes concealed interlock connection system
                  without exposing screws that gives nice appearance surface The
                  PD wall system is an ideal architectural application for
                  office / commercial buildings. PU50/MW60Sandwich System<br />
                  The board surface is made of two layers of colored steel
                  plates, which are continuously foamed with high-pressure
                  injection of flame-retardant polyurethane foam and filled with
                  rock wool. Available in PU50 polyurethane and MW60 stone wool
                  pods, with smooth, special low grooves and serrated
                  stripes.<br />
                  CP Double Wall Panel System<br />
                  It is composed of any kind of roof panel and LND inner layer
                  board, sandwiched with glass wool insulation layer, the inner
                  layer board can provide a smooth surface for the inner layer
                  of the roof, and protect the roof insulation layer at the same
                  time, and the inner layer board is used for low wave peaks of
                  the roof and wall.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>roof system</h2>
                <p>
                  SD Roof System<br />
                  SD roof system is formed in the construction site, using a
                  special closed type fixing set to have air-tight connection
                  with 360 degree double scrolled roof seaming set (patent
                  nr.：ZL01237936.0).<br />
                  The entire roof becomes an airtight membrane after all panels
                  are completely seamed together, providing strong wind uplift
                  resistance, high efficient insulation and excellence for
                  weather tightness.
                  <br />
                  LD Roof System<br />
                  Our LD model roof plate is fixed by two special clips
                  (interlocked) and by sandwich fixing set. Excellent resistance
                  to wind load, snow load and loading capacity. The movable
                  steel panel function avoids possible damage due to heat
                  expansion or cold shrinkage. The maximum length of single roof
                  plate is 200m, which is convenient for large-scale building
                  project.
                  <br />
                  KD Roof System<br />
                  The KD Roof system utilizes concealed clip connection set to
                  interlock with the steel panel. High wind-uplift resistance
                  capacity and good weatherproof. Panel is allowed to move due
                  to thermal expansion and cold contraction that can avoid
                  damage to the panel. Application to wider roof building is
                  feasible.
                  <br />
                  CP Roof System<br />
                  CP roof system is an application by using a LND liner panel to
                  match any type of our roof panels. A glass wool material is
                  used as insulation between the two panels. The LND liner panel
                  can provide clean and neat appearance under the roof and to
                  protect the insulation layer, the LND is used in the lower
                  level of wave crest.
                  <br />
                  CD II Roofing System<br />
                  The screw penetrates directly through the steel plate fixing
                  system A universal and economical roofing system for roofs
                  with narrow widths The special connection method is effective
                  against wind and leakage
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>Purlins & Girts</h2>
                <p>
                  Secondary systems are based on purlins and girts that are
                  attached to roof beams and columns as supporting frame for
                  roof and wall panel.<br />
                  Purlin and girt are high tensile pre-coated steel with either
                  continuous hot-dipped galvanized or aluminum/zinc
                  electro-plated steel, providing the best corrosion protection
                  and clean finishing surface.<br />
                  The shapes of purlin as well as girt include C-section and Z-
                  section.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>main steel system</h2>
                <p>
                  The primary framing systems are composed of girders and
                  columns, made by build-up H-section steel members.<br />
                  National standard steel Q235B or Q345B are selected to conform
                  to the engineering design.<br />
                  Various rigid frame styles are specifically designed for
                  selection to each requirement.<br />
                  Welding is carried out to meet national standards by advanced
                  automatic welding equipments.<br />
                  All steels are cleaned with imported multiple spray beads
                  shot-blasting equipment to insure all steel surfaces are
                  thoroughly cleaned.<br />
                  Rust-resisting primer is painted to ensure that steel be
                  protected from corrosion.
                </p>
              </div>
            </li>
            <li>
              <div>
                <h2>prefabricated structure</h2>
                <p>
                  The low-rise pre-engineered building system is a modernized
                  building system. All materials are made of steel and metal.
                  Design is optimized to job site. All parts installed together
                  with bolts and screws like a model kit without any field
                  welding and fabrication requirements.<br />
                  Features: shorter construction schedule, quality easy to
                  control, low maintenance, more usable space, column spaces can
                  be set based on production layout requirements, esthetical and
                  modernize, easy and flexible for future expansion.<br />
                  It is very commonly used in large-scale and large span
                  factory, warehouse and aircraft hangar.
                </p>
              </div>
            </li>
          </ul>

          <button class="cd-close jzbutton">Close</button>
        </div>
      </div>
      <div class="hidden-xs">
        <div class="container" style="height: 80vh">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Ventilating System</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz2" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>HUAYIN Natural Ventilator System</h3>
              <p>
                HUAYIN natural ventilator system utilizes the indoor temperature
                difference that produces thermo dynamic force, this effect
                further creates suctions inside the building: fresh air can be
                drawn from the openings on the lower part of the walls into the
                building. Polluted hot air and poisonous gas can be exhausted
                from inside the building.<br />
                Advantages compared to the power generated ventilator system:<br />
                •Economical and low cost.<br />
                •Automatic adjustment to the air-exchange quantity.<br />
                •Quiet and no vibration.<br />
                •Professional design, fast and convenient installation
              </p>
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Translucent System</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>Translucent Panel</h3>
              <p>
                Translucent panel provides most effective and harmless natural
                light for the building.No electricity and maintenance is
                required.<br />
                Panel surface laminated with DuPont”s Melinex polyester film
                that resist 99%of UV rays and reduce surface erosion.<br />
                Light transmission value: transparent color(70%); milky white
                color(58%)
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz3" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Floor System</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz4" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>multilayer system</h3>
              <p>
                It has the same characteristics as the low-rise prefabricated
                steel structure system, and compared with the traditional
                reinforced concrete structure, the multi-storey steel structure
                system can more effectively shorten the construction period and
                control the construction quality. <br />
                Floor thicknesses and column sizes can be reduced to a minimum,
                resulting in a reduction in building height, more usable space,
                and unnecessary heat and air conditioning supplies. <br />
                The lightweight structure reduces the load on the foundation,
                thus saving the cost of the foundation. <br />
                The floor can be made of Huayin composite floor slabs poured
                with concrete on site. The floor deck system, which can be
                quickly applied under any climatic conditions, has long been
                recognized by designers for its light weight, high strength and
                weight contrast performance, durability and beauty.
              </p>
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Wall System</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <p>
                CDII Wall System<br />
                Wall panel system with exposed screws.Economical and easy
                assembly type, widely applied in all types of building.<br />
                RD Wall System<br />
                RD wall has unique wave crest that generate different vertical
                shadow lines on the walls that gives a unique architectural
                view.Screws are semi-hidden in corrugation that gives the wall a
                clear look.<br />
                PD Wall System<br />
                PD wall system utilizes concealed interlock connection system
                without exposing screws that gives nice appearance surface.The
                40mm thick wall panel provides a space that allows the thicker
                insulation material to achieve higher energy efficiency.<br />
                PU50/MW60 sandwich system<br />
                The board surface is made of two layers of colored steel plates,
                Available in PU50 polyurethane and MW60 stone wool pods, with
                smooth, special low grooves and serrated stripes. <br />
                CP double wallplate system<br />
                The inner layer board can provide a smooth surface for the inner
                layer of the roof, and protect the roof insulation layer at the
                same time, and the inner layer board is used for low wave peaks
                of the roof and wall.
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz5" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Roof System</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz6" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <p>
                SD Roof System<br />
                SD roof system is formed in the construction site, using a
                special closed type fixing set to have air-tight connection with
                360 degree double scrolled roof seaming set.The entire roof
                becomes an airtight membrane after all panels are completely
                seamed together, providing strong wind uplift resistance, high
                efficient insulation and excellence for weather tightness.<br />
                LD Roof System<br />
                Our LD model roof plate is fixed by two special clips and by
                sandwich fixing set. Excellent resistance to wind load, snow
                load and loading capacity. The maximum length of single roof
                plate is 200m, which is convenient for large-scale building
                project.
                <br />
                KD Roof System<br />
                The KD Roof system utilizes concealed clip connection set to
                interlock with the steel panel. High wind-uplift resistance
                capacity and good weatherproof. Panel is allowed to move due to
                thermal expansion and cold contraction that can avoid damage to
                the panel.
                <br />
                CP Roof System<br />
                CP roof system is an application by using a LND liner panel to
                match any type of our roof panels. A glass wool material is used
                as insulation between the two panels. The LND liner panel can
                provide clean and neat appearance under the roof and to protect
                the insulation layer, the LND is used in the lower level of wave
                crest.
                <br />
              </p>
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Purlins & Girts</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>substructural system</h3>
              <p>
                Secondary systems are based on purlins and girts that are
                attached to roof beams and columns as supporting frame for roof
                and wall panel.<br />
                Purlin and girt are high tensile pre-coated steel with either
                continuous hot-dipped galvanized or aluminum/zinc electro-plated
                steel, providing the best corrosion protection and clean
                finishing surface.<br />
                The shapes of purlin as well as girt include C-section and Z-
                section.
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz7" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-4"
            style="height: 100%; background-color: #111"
          ></div>
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Main Steel System</h1>
            </div>
          </div>
          <div class="content">
            <div class="img-container">
              <img v-lazy="hyjz8" alt="Lazy-loaded Image" />
            </div>
            <div class="text-container">
              <h3>main structural system</h3>
              <p>
                The primary framing systems are composed of girders and columns,
                made by build-up H-section steel members. National standard
                steel Q235B or Q345B are selected to conform to the engineering
                design. Various rigid frame styles are specifically designed for
                selection to each requirement.<br />
                Welding is carried out to meet national standards by advanced
                automatic welding equipments. All steels are cleaned with
                imported multiple spray beads shot-blasting equipment to insure
                all steel surfaces are thoroughly cleaned. Rust-resisting primer
                is painted to ensure that steel be protected from corrosion.
              </p>
            </div>
          </div>
        </div>
        <div class="container" style="height: 80vh">
          <div
            class="col-md-8"
            style="height: 100%; background-color: #fff"
          ></div>
          <div
            class="col-md-4"
            style="height: 100%; background-color: #535556"
          ></div>
          <div class="box">
            <div class="box-inner">
              <h1>Prefabricated Structure</h1>
            </div>
          </div>
          <div class="content">
            <div class="text-container" style="float: left">
              <h3>low-rise pre-engineered building system</h3>
              <p>
                The low-rise pre-engineered building system is a modernized
                building system. All materials are made of steel and metal.
                Design is optimized to job site. All parts installed together
                with bolts and screws like a model kit without any field welding
                and fabrication requirements.<br />
                Features: shorter construction schedule, quality easy to
                control, low maintenance, more usable space, column spaces can
                be set based on production layout requirements, esthetical and
                modernize, easy and flexible for future expansion.<br />
                It is very commonly used in large-scale and large span factory,
                warehouse and aircraft hangar.
              </p>
            </div>
            <div
              class="img-container"
              style="float: right; margin-right: 0; margin-left: 20px"
            >
              <img v-lazy="hyjz9" alt="Lazy-loaded Image" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .cd-content-block -->
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted() {
    // 产品介绍
    $(document).ready(function ($) {
      //store DOM elements
      var imageWrapper = $('.cd-images-list'),
        imagesList = imageWrapper.children('li'),
        contentWrapper = $('.cd-content-block'),
        contentList = contentWrapper.children('ul').eq(0).children('li'),
        blockNavigation = $('.block-navigation'),
        blockNavigationNext = blockNavigation.find('.cd-next'),
        blockNavigationPrev = blockNavigation.find('.cd-prev'),
        //used to check if the animation is running
        animating = false

      //on mobile - open a single project content when selecting a project image
      imageWrapper.on('click', 'a', function (event) {
        event.preventDefault()
        var device = MQ()
        console.log(device)
        device == 'mobile' &&
          updateBlock(imagesList.index($(this).parent('li')), 'mobile')
      })

      //on mobile - close visible project when clicking the .cd-close btn
      contentWrapper.on('click', '.cd-close', function () {
        var closeBtn = $(this)
        if (!animating) {
          animating = true

          closeBtn
            .removeClass('is-scaled-up')
            .one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentWrapper
                  .removeClass('is-visible')
                  .one(
                    'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    function () {
                      animating = false
                    }
                  )

                $('.cd-image-block').removeClass('content-block-is-visible')
                closeBtn.off(
                  'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
                )
              }
            )
        }
      })

      //on desktop - update visible project when clicking the .block-navigation
      blockNavigation.on('click', 'button', function () {
        var direction = $(this),
          indexVisibleblock = imagesList.index(
            imageWrapper.children('li.is-selected')
          )

        if (!direction.hasClass('inactive')) {
          var index = direction.hasClass('cd-next')
            ? indexVisibleblock + 1
            : indexVisibleblock - 1
          updateBlock(index)
        }
      })

      //on desktop - update visible project on keydown
      $(document).on('keydown', function (event) {
        var device = MQ()
        console.log(event.which)
        if (
          event.which == '39' &&
          !blockNavigationNext.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to next project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) + 1
          )
        } else if (
          event.which == '37' &&
          !blockNavigationPrev.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to previous project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) - 1
          )
        }
      })

      function updateBlock(n, device) {
        if (!animating) {
          animating = true
          var imageItem = imagesList.eq(n),
            contentItem = contentList.eq(n)

          classUpdate($([imageItem, contentItem]))

          if (device == 'mobile') {
            contentItem.scrollTop(0)
            $('.cd-image-block').addClass('content-block-is-visible')
            contentWrapper
              .addClass('is-visible')
              .one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function () {
                  contentWrapper.find('.cd-close').addClass('is-scaled-up')
                  animating = false
                }
              )
          } else {
            contentList.addClass('overflow-hidden')
            contentItem.one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentItem.siblings().scrollTop(0)
                contentList.removeClass('overflow-hidden')
                animating = false
              }
            )
          }

          //if browser doesn't support transition
          if ($('.no-csstransitions').length > 0) animating = false

          updateBlockNavigation(n)
        }
      }

      function classUpdate(items) {
        items.each(function () {
          var item = $(this)
          item
            .addClass('is-selected')
            .removeClass('move-left')
            .siblings()
            .removeClass('is-selected')
            .end()
            .prevAll()
            .addClass('move-left')
            .end()
            .nextAll()
            .removeClass('move-left')
        })
      }

      function updateBlockNavigation(n) {
        n == 0
          ? blockNavigationPrev.addClass('inactive')
          : blockNavigationPrev.removeClass('inactive')
        n + 1 >= imagesList.length
          ? blockNavigationNext.addClass('inactive')
          : blockNavigationNext.removeClass('inactive')
      }

      function MQ() {
        return window
          .getComputedStyle(imageWrapper.get(0), '::before')
          .getPropertyValue('content')
          .replace(/'/g, '')
          .replace(/"/g, '')
          .split(', ')
      }
    })
  },
  data() {
    return {
      hyjz1: require('@/components/img/hyjz/hysg.jpg'),
      hyjz2: require('@/components/img/hyjz/cpjs1.jpg'),
      hyjz3: require('@/components/img/hyjz/cpjs2.jpg'),
      hyjz4: require('@/components/img/hyjz/cpjs3.jpg'),
      hyjz5: require('@/components/img/hyjz/cpjs4.jpg'),
      hyjz6: require('@/components/img/hyjz/cpjs5.jpg'),
      hyjz7: require('@/components/img/hyjz/cpjs6.jpg'),
      hyjz8: require('@/components/img/hyjz/cpjs7.jpg'),
      hyjz9: require('@/components/img/hyjz/cpjs8.jpg'),
    }
  },
  methods:{
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
  }
}
</script>

<style scoped>
#hysg,
#cpjs,
#hyzp {
  margin-top: -83px;
  padding-top: 83px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyjz/one1.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 40px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: -75px;
  left: -25px;
}

#ss_menu div:nth-child(2) {
  top: -25px;
  left: -75px;
}

/* #ss_menu div:nth-child(3) {
  top: -130px;
  left: 0px;
} */
/* hysg */
.jzcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.jzh {
  text-align: center;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: #262626 solid 1px;
}
.jzp {
  font-weight: 400;
  font-size: 20px;
}
.jzleft {
  flex: 1;
  margin: 20px;
  padding: 20px;
  background-color: rgba(250, 250, 250, 0.1);
  /* text-align: center;
    line-height: auto; */
  color: #000;
  /* box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px; */
}

.jzright {
  flex: 1;
  margin: 20px;
  padding: 20px;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.jzimg {
  max-width: 100%;
  height: auto;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}
.jzcp {
  width: 99vw;
  height: 80vh;
}
.hyp {
  font-size: 20px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .hyp {
    font-size: 14px;
    font-weight: 400;
  }
  .jzleft,
  .jzright {
    flex: 100%;
  }

  .jzleft {
    order: 1;
    margin: 0;
  }
  .jzh {
    text-align: center;
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .jzp {
    font-weight: 100;
    font-size: 1.25em;
  }
  .jzright {
    order: 2;
  }
  .jzcp {
    width: 100vw;
    height: auto;
  }
  .jzcph {
    font-size: 35px !important;
    font-weight: 500 !important;
  }
}
/* 产品内容 */
/* -------------------------------- 

Images block

-------------------------------- */
.jzcph {
  text-align: center;
  padding: 30px 0;
  font-size: 50px;
  font-weight: 600;
  border-top: #000 solid 1px;
  border-bottom: #000 solid 1px;
}
.cd-image-block {
  position: relative;
}
.cd-image-block::before {
  /* this is the layer used to cover the .cd-image-block when the content block becomes visible - mobile only */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(52, 54, 66, 0.6);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
}
.cd-image-block.content-block-is-visible::before {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s;
}
@media only screen and (min-width: 768px) {
  .cd-image-block::before {
    display: none;
  }
}

.cd-images-list::before {
  /* never visible - this is used in jQuery to check the current MQ */
  content: 'mobile';
  display: none;
}
.cd-images-list > li {
  height: 250px;
  background: #979c9c url(@/components/img/hyjz/jz1.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(2) {
  background: #464d75 url(@/components/img/hyjz/jz2.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(3) {
  background: #982b3c url(@/components/img/hyjz/jz3.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(4) {
  background: #338899 url(@/components/img/hyjz/jz4.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(5) {
  background: #f55555 url(@/components/img/hyjz/jz5.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(6) {
  background: #a0fe65 url(@/components/img/hyjz/jz6.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(7) {
  background: #f6ceec url(@/components/img/hyjz/jz7.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(8) {
  background: #1d6fa3 url(@/components/img/hyjz/jz8.png) no-repeat center;
  background-size: cover;
}
.cd-images-list > li > a {
  /* used to vertically align the h2 child -  mobile version only */
  display: table;
  height: 100%;
  width: 100%;
}
.cd-images-list h2 {
  /* used to vertically align h2 -  mobile version only */
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 3rem;
  color: #ffffff;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (min-width: 768px) {
  .cd-images-list::before {
    /* never visible - this is used in jQuery to check the current MQ */
    content: 'desktop';
  }
  .cd-images-list > li > a {
    display: block;
    padding: 4em 3em;
    cursor: default;
    pointer-events: none;
  }
  .cd-images-list h2 {
    font-size: 5.5rem;
    text-align: left;
  }
}

/* -------------------------------- 

Content block

-------------------------------- */
.cd-content-block {
  /* move the block outside the viewport (to the right) - mobile only */
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -ms-transform: translateX(100%);
  -o-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}
.cd-content-block.is-visible {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  -o-transform: translateX(0);
  transform: translateX(0);
}
@media screen and (max-width: 768px) {
  .cd-content-block.is-visible {
    margin-top: 56px;
  }
}
.cd-content-block > ul {
  border: 1px solid black;
  height: 100%;
}
.cd-content-block > ul > li {
  position: absolute;
  height: 100%;
  padding: 1em;
  /* overflow-y: scroll; */
  background-color: #ffffff;
  opacity: 0;
  visibility: hidden;
}
.cd-content-block > ul > li.is-selected {
  /* this is the selected content */
  position: relative;
  opacity: 1;
  visibility: visible;
  -webkit-overflow-scrolling: touch;
}
.cd-content-block h2 {
  line-height: 1.2;
  font-weight: 700;
  font-size: 2.3rem;
  margin-bottom: 1em;
}
.cd-content-block p {
  margin-bottom: 1em;
  line-height: 1.3;
  color: #85868d;
  font-size: 14px;
}
.cd-content-block .cd-close {
  /* 'X' icon to close the content block -  mobile only */
  position: fixed;
  top: 0;
  right: 0;
  height: 44px;
  width: 44px;
  /* image replacement */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
  color: transparent;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  transition: transform 0.2s;
}
.cd-content-block .cd-close::after,
.cd-content-block .cd-close::before {
  /* these are the 2 lines of the 'X' icon */
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 24px;
  background-color: #343642;
  /* Force Hardware Acceleration */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
.cd-content-block .cd-close::after {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.cd-content-block .cd-close::before {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
}
.cd-content-block .cd-close.is-scaled-up {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
.no-touch .cd-content-block .cd-close.is-scaled-up:hover {
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -ms-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}
@media only screen and (min-width: 768px) {
  .cd-content-block {
    /* reset style */
    position: static;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-content-block p {
    margin-bottom: 1em;
    line-height: 1.6;
    color: #85868d;
    font-size: 20px;
  }
  .cd-content-block > ul > li {
    /* reset style */
    opacity: 1;
    visibility: visible;
    padding: 2em;
  }
  .cd-content-block > ul > li.overflow-hidden {
    /* this class is used during the animation (slider change) to hide the scrolling bar */
    overflow: hidden;
  }
  .cd-content-block h2 {
    font-size: 3rem;
  }
  .cd-content-block .cd-close {
    display: none;
  }
}

/* ---------------------------------------------- 

Desktop slider - both image and content blocks

---------------------------------------------- */
@media only screen and (min-width: 768px) {
  .cd-image-block {
    /* slider style - desktop version only */
    width: 40%;
    float: left;
    height: 80vh;
    overflow: hidden;
  }
  .cd-content-block {
    /* slider style - desktop version only */
    width: 60%;
    float: left;
    height: 80vh;
    overflow: hidden;
  }
  .cd-image-block > ul,
  .cd-content-block > ul {
    position: relative;
    height: 100%;
  }
  .cd-image-block > ul > li,
  .cd-content-block > ul > li {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    /* Force Hardware Acceleration */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    /* by default, the items are moved to the right - relative to their parent elements */
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
    -webkit-transition: -webkit-transform 0.5s;
    -moz-transition: -moz-transform 0.5s;
    transition: transform 0.5s;
  }
  .cd-image-block > ul > li.is-selected,
  .cd-content-block > ul > li.is-selected {
    /* this is the visible item */
    position: absolute;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-image-block > ul > li.move-left,
  .cd-content-block > ul > li.move-left {
    /* this is the item hidden on the left */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
/* -------------------------------- 

Slider navigation

-------------------------------- */
.block-navigation {
  /* this is the slider navigation - desktop version only */
  display: none;
}
@media only screen and (min-width: 768px) {
  .block-navigation {
    display: block;
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 39px !important;
  }
  .block-navigation::after {
    clear: both;
    content: '';
    display: table;
  }
  .block-navigation li {
    position: static !important;
    width: 50% !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    -webkit-transition: background 0.2s;
    -moz-transition: background 0.2s;
    transition: background 0.2s !important;
    transform: translateX(0) !important;
  }
  .block-navigation li:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .block-navigation li:first-of-type {
    float: left;
  }
  .block-navigation li:last-of-type {
    float: right;
  }
  .block-navigation button {
    display: block;
    height: 100%;
    width: 100%;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .block-navigation button.inactive {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

/* -------------------------------- 

Javascript disabled

-------------------------------- */
@media only screen and (min-width: 768px) {
  .no-js .cd-content-block {
    display: none;
  }

  .no-js .cd-image-block {
    width: 100%;
    overflow: visible;
  }

  .no-js .cd-images-list::after {
    clear: both;
    content: '';
    display: table;
  }

  .no-js .cd-images-list > li {
    position: static;
    width: 50%;
    float: left;
    height: 400px;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .no-js .cd-images-list > li.is-selected {
    position: static;
  }

  .no-js .cd-images-list > li > a {
    cursor: pointer;
    pointer-events: auto;
  }

  .no-js .block-navigation {
    display: none;
  }
}
.jzbutton {
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 1.6rem;
}
/* 产品展示 */
:root {
  --color-primary: #000;
  --color-secondary: #fff;
  --color-text: #333;
  --font-size-title: 2rem;
  --font-size-subtitle: 1.5rem;
  --font-size-text: 1rem;
}

.container {
  padding: 0;
  margin: 0;
  width: 100%;
  position: relative;
}

.container .content {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.container .content .img-container {
  float: left;
  margin-right: 20px;
}

.container .content .img-container img {
  width: 40vw;
  height: 60vh;
}

.container .content .text-container {
  border: 1px solid #000;
  border-radius: 10px;
  float: right;
}
.container .content .text-container h3 {
  padding: 10px;
  margin: 0;
  text-align: center;
  font-size: 24px;
}
.container .content .text-container p {
  padding: 15px;
  font-size: 18px;
  line-height: 1.6;
}
.container .content .img-container img {
  border: 5px solid var(--color-primary);
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}
.container {
  background: linear-gradient(
    to bottom,
    var(--color-primary),
    var(--color-secondary)
  );
}
.box {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  background-color: #fff;
  width: 95vw;
  padding: 5px;
  border: 2px solid #000;
  text-align: center;
}

.box:before,
.box:after {
  content: '•';
  position: absolute;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #000;
  border: 2px solid #000;
  line-height: 12px;
  top: 5px;
  text-align: center;
}

.box:before {
  left: 5px;
}

.box:after {
  right: 5px;
}

.box .box-inner {
  position: relative;
  border: 2px solid #000;
}

.box .box-inner:before,
.box .box-inner:after {
  content: '•';
  position: absolute;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #000;
  border: 2px solid #000;
  line-height: 12px;
  bottom: -2px;
  text-align: center;
}

.box .box-inner:before {
  left: -2px;
}

.box .box-inner:after {
  right: -2px;
}
.box .box-inner h1 {
  margin: 10px 0;
  font-weight: 20px !important;
}
p {
  margin: 0 !important;
}
@media screen and (min-width: 2000px) {
  .jzh {
    font-size: 60px;
    margin-bottom: 60px;
    padding-bottom: 60px;
  }
  .jzp {
    font-size: 30px;
  }
  .jzleft {
    margin: 60px;
    padding: 60px;
  }
  .jzimg {
    height: 600px;
    width: 100%;
  }
  .jzcph {
    font-size: 60px;
  }
  .box .box-inner h1 {
    margin: 20px 0;
  }
  .container .content .text-container h3 {
    font-size: 30px;
  }
  .container .content .text-container p {
    font-size: 25px;
  }
  .conHeight {
    height: 67vh;
  }
  .container .content .img-container img {
    height: 55vh;
  }
  /* 头部 */
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
}
</style>
